<template>
  <div class="tw-relative" ref="target">
    <slot name="trigger" />
    <div
      v-if="isVisible"
      class="tw-absolute tw-right-[-16px] tw-w-[360px] tw-rounded-b-md tw-shadow tw-z-[60] tw-translate-y-[10px]"
    >
      <div
        class="tw-absolute tw-top-[-8px] tw-right-[18px] tw-w-0 tw-h-0 tw-border-l-[10px] tw-border-l-[transparent] tw-border-r-[10px] tw-border-r-[transparent] tw-border-b-[10px] tw-border-b-primary-grey-700"
      ></div>
      <div class="tw-bg-primary-grey-700 tw-text-white tw-py-3 tw-rounded-t-md">
        <slot name="title" />
      </div>
      <div class="tw-rounded-b-md tw-text-primary-grey-950 tw-py-3 tw-bg-white">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";

const target = ref(null);
const isVisible = ref(false);

const toggleMenuVisibility = () => {
  isVisible.value = !isVisible.value;
};

onClickOutside(target, () => {
  if (isVisible.value) {
    isVisible.value = false;
  }
});

defineExpose({ toggleMenuVisibility });
</script>
